import React from "react";
import { Provider } from "react-redux";
import "./toast.scss";
import store from "../redux/store";
import Toasts from "./app";

function ToastContainer({ autoCloseTimeout = 0.15 }) {
  return (
    <Provider store={store}>
      <Toasts autoCloseTimeout={autoCloseTimeout} />
    </Provider>
  );
}

export default ToastContainer;
